import React, { useState, useEffect, useRef } from "react";
import { FormContent } from "./styled"
import axios from "axios";
import 'react-calendar/dist/Calendar.css';
import { Button, Form, Input, Radio, DatePicker, Space, Checkbox, Modal, Skeleton, Tooltip, ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import { SaveOutlined, ExclamationCircleOutlined, CopyOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import CredenciaisAcesso from "./CredenciaisDeAcesso";
import { formatCNPJ } from "../../../../../../function/utilis/function.js"

import NotaFiscal from "../../../../NotaFiscal/index.jsx";
import SituacaoTarefa from "../index.jsx";

import { FormatItem } from "../styled.jsx";

import { Box, CircularProgress } from "@mui/material";

import TextArea from "antd/es/input/TextArea.js";
import { Method_POST_REST } from "../../../../../../service/api.js";
import { IoAddOutline } from "react-icons/io5";
import { TfiWorld } from "react-icons/tfi";
import TabelaCorrelacionadas from "./TabelaCorrelacionada/index.jsx";
import UploadDoc from "./UploadDoc/index.jsx";
import ModalAdicionarInformacoes from "../ModalAdicionarInformaçoes/index.jsx";

export function PendentesEmitir({
  onClose,
  taskId,
  obrigacaoId,
  id,
  recorrencia,
  data,
  clienteId,
  emitidas,
  pendentes,
  Dadoscontexto
}) {
  const [form] = Form.useForm();
  const [selectedOption, setSelectedOption] = useState('cadastro');
  const [isModalAddInformacoesAdicionais, setIsModalAddInformacoesAdicionais] = useState(false);
  const [isLoadingAddInfo, setIsLoadingAddInfo] = useState(false);
  const [isDisabled] = useState(true);
  const [loadings, setLoadings] = useState([]);
  const [isOptionsMotivo, setIsOptionsMotivo] = useState([]);
  const [isLoadingForm, setIsLoadingForm] = useState(false);
  const [isContador, setIsContador] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFile, setIsFile] = useState({});
  const [isFileName, setIsFileName] = useState();
  const [isModalEmitirClose, setIsModalEmitirClose] = useState(true);
  const situacaoTarefaRef = useRef(null);
  const [SituacaoMotivo, setSituacaoMotivo] = useState([]);
  const [isEmitida, setIsEmitida] = useState(false);
  const [disableValue, setDisableValue] = useState();
  const [isValidate, setIsvalidate] = useState(true);
  const [isTarefaCorrelacionada, setIsTarefaCorrelacionada] = useState(false);
  const [tarefasCorrelacionadas, setTarefasCorrelacionadas] = useState([]);
  const [isModalConfirmRetificacao, setIsModalConfirmRetificacao] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [files, setIsFiles] = useState([]);

  const [info, setInfo] = useState("");

  const [infoConteudo] = useState("");


  const [retificacaoFile, setRetificacao] = useState({
    "DATA_COMPETENCIA": "",
    "FORMATO_ARQUIVO": "",
    "CNPJ": "",
    "VALOR_GUIA": "",
    "DATA_VENCIMENTO_GUIA": ""
  })

  const [formulario, setFormulario] = useState({
    clienteId: "",
    clienteCnpj: "",
    nomeRazaoSocial: "",
    inscricaoEstadual: "",
    inscricaoMunicipal: "",
    cnaeAnexos: "",
    obrigacao: "",
    sigla: "",
    nome: "",
    mesRef: "",
    dataVenc: "",
    valor: "",
    urlSite: "",
    situacao: "",
    motivo: "",
    parcelamentoId: "",
    descricao: "",
    liberado: true,
  });

  useEffect(() => {
    if (retificacaoFile.VALOR_GUIA != null && retificacaoFile.VALOR_GUIA > 0) {

      setIsModalConfirmRetificacao(true);
    }
  }, [retificacaoFile]);


  const [correlacionadaParam, setCorrelacionadaParam] = useState({
    dataReferencia: "",
    dataVencimento: "",
    descricao: "",
    nome: "",
    dia: "",
    obrigacaoId: "",
    situacaoId: "",
  });

  useEffect(() => {
    let height = document.documentElement.scrollHeight;
    window.parent.postMessage({ frameHeight: height, scrollUp: true }, "*");
  });

  useEffect(() => {
    fetchData(taskId, obrigacaoId, data);
  }, []);

  //SERVICE APLICADO
  const fetchData = async (taskId, obrigacaoId, data) => {
    const url = "/contador/obrigacao/calcular"
    const param = {
      dataVencimento: data,
      cliente: {
        id: taskId
      },
      obrigacao: {
        id: obrigacaoId
      }
    }

    setIsLoadingForm(true);
    try {
      const response = await Method_POST_REST(url, param);

      if(response){
        //console.log("response:", response);

        const motivos = response.obrigacao?.motivos?.map(motivo => ({
          value: motivo.id,
          label: motivo.nome

        })) || [];

        //console.log("motivos:", motivos)

        setIsOptionsMotivo(motivos);

        if (response.obrigacao?.correlacionadas != null && response.obrigacao?.correlacionadas.length > 0) {
          setTarefasCorrelacionadas(response.obrigacao?.correlacionadas);

          // Cria um array temporário com todos os objetos mapeados
          const correlacionadasArray = response.obrigacao?.correlacionadas.map(c => ({
            dataReferencia: c.dataReferencia,
            dataVencimento: c.dataVencimento,
            descricao: c.obrigacao.nome,
            nome: c.obrigacao.sigla,
            dia: c.obrigacao.dia,
            obrigacaoId: c.obrigacao.id,
            situacaoId: c.obrigacao.situacao.id,
          }));

          // Define o estado de uma vez, evitando sobrescrever a cada iteração
          setCorrelacionadaParam(correlacionadasArray);
        } else {
          setIsTarefaCorrelacionada(false);
        }

        const { cliente, obrigacao, situacao } = response;

        setSituacaoMotivo(response.obrigacao?.situacoes);

        const contador = JSON.parse(sessionStorage.getItem('USER'));

        setFormulario(prevState => ({
          ...prevState,
          clienteId: cliente.id,
          clienteCnpj: cliente.cnpj,
          nomeRazaoSocial: cliente.nome,
          inscricaoEstadual: cliente.ie,
          inscricaoMunicipal: cliente.im,
          cnaeAnexos: cliente.cnaeAnexos,
          obrigacao: obrigacao.id,
          sigla: obrigacao.sigla,
          nome: obrigacao.nome,
          situacao: situacao.id,
          liberado: formulario.liberado,
          motivo: '',
          descricao: response.obrigacao?.nome,
          valor: response.valor,
          urlSite: obrigacao.urlPrefeitura,
          dataVenc: dayjs(response.dataVencimento).toISOString(),
          mesRef: dayjs(response.dataReferencia).date(15).toISOString(),
          parcelamentoId: Dadoscontexto.clienteObrigacao.parcelamento.id


        }));

        if (response.obrigacao?.tipo.id && !contador.perfis.some(perfil => perfil.id === "GRP_PORTAL_ADMIN") && !contador.perfis.some(perfil => perfil.id === "GRP_PORTAL_LDR_CONTADOR")) {
          setIsContador(true)
        }

        }
    

    } catch (error) {
      console.log(error)
    } finally {
      setIsLoadingForm(false);
    }

  }

  const salvarCadastroDeGuia = async () => {
    const url = "/portal/rest/contador/obrigacao/cadastrar";

    const correlacionada = correlacionadaParam.length > 0 ? correlacionadaParam[0] : null;

    const Objcorrelacionadas = correlacionada ? {
      obrigacao: {
        id: correlacionada.obrigacaoId,
        dia: correlacionada.dia,
      },
      dataVencimento: correlacionada.dataVencimento,
      dataReferencia: correlacionada.dataReferencia,
      nome: correlacionada.nome,
      descricao: (formulario.situacao === "S" ? "Sem Movimento" : formulario.descricao) + " - ref. " + dayjs(formulario.mesRef).format('MM/YYYY') + " em decorrência da obrigação " + formulario.sigla + (formulario.situacao === "S" ? " - Sem Movimento" : formulario.situacao),
      situacao: {
        id: formulario.situacao,
      }
    } : null;

    const param = {
      cliente: {
        id: formulario.clienteId.toString(),
      },
      obrigacao: {
        id: formulario.obrigacao.toString(),
        //...(formulario.situacao === "S" && Objcorrelacionadas != null ? { correlacionadas: [Objcorrelacionadas] } : {}),
        ...(formulario.situacao === "S" && Objcorrelacionadas ? { correlacionadas: [Objcorrelacionadas] } : {}),
      },
      dataReferencia: formulario.mesRef.toString(),
      dataVencimento: formulario.dataVenc.toString(),
      situacao: {
        id: formulario.situacao === "Emitida" ? "E" : formulario.situacao,
      },
      nome: formulario.nome,
      descricao: (formulario.situacao === "S" ? "SEM MOVIMENTAÇÃO" : formulario.descricao) + " - ref. " + dayjs(formulario.mesRef).format('MM/YYYY'),
      valor: parseFloat(formulario.valor),
      liberado: formulario.liberado,
      parcelamento: {
        id: formulario.parcelamentoId,
      },
    };

    //verifica se  existe algum arquivo importado no files
    /*if (files.length === 0) {
      setInfo("Você precisa importar um documento, para salvar");
      return;
    }*/

    if (isValidate) {
      try {
        const response = await axios.post(url, param, {withCredentials: true,});
        if (response.data.erro) {
          toast.error(response.data.erro.mensagem);
        } else {
          files.forEach((file) => {
            uploadFile(response.data.id, file);
          });
          toast.success("Guia Imposto/Declaração salvo com sucesso!");
          emitidas(id, recorrencia, data, clienteId);
          pendentes(id, recorrencia, data, clienteId);
          onClose();
        }
      } catch (error) {
        toast.error(
          "Não foi possível realizar a ação, revise os dados e tente novamente em alguns segundos.",
          error
        );
      }
    } else {
      toast.error("Substitua o arquivo para um válido.");
    }
  };

  let validaDateForm = (response) => {
    try {
      return response.data.DATA_VENCIMENTO_GUIA.split("/");
    } catch {
      return null;
    }
  }
  
  const ModalConfirmValor = () => {

    const handleButtonClick = (value) => {
      if (value === 1) {
        setDisableValue(true);
        if (dayjs(formulario.dataVenc).format('MM/YYYY') != dayjs(retificacaoFile.DATA_VENCIMENTO_GUIA, 'DD/MM/YYYY').format('MM/YYYY')) {
          setFormulario(prevState => ({
            ...prevState,
            valor: retificacaoFile.VALOR_GUIA,
            dataVenc: dayjs(retificacaoFile.DATA_VENCIMENTO_GUIA, 'DD/MM/YYYY').format('DD-MM-YYYY'),
          }));
        } else {
          setFormulario(prevState => ({
            ...prevState,
            valor: retificacaoFile.VALOR_GUIA,
          }));
        }
      } else {
        setDisableValue(false);

      }
      setIsModalConfirmRetificacao(false);

    };

    return (
      <>
        <Modal
          title={<ExclamationCircleOutlined style={{ fontSize: "larger", color: "darkorange" }} />}
          open={true}
          onOk={() => handleButtonClick(1)}  // Passando uma função de callback
          onCancel={() => handleButtonClick(2)}  // Passando uma função de callback
        >
          {isLoadingForm ? (
            <div>
              <Box className="loading">
                <div style={{ textAlign: "center" }}>
                  <CircularProgress />
                </div>
              </Box>
            </div>
          ) : (
            <p>Deseja confirmar a emissão do documento no valor de <strong>R$ {retificacaoFile.VALOR_GUIA}</strong> com vencimento para <strong>{retificacaoFile.DATA_VENCIMENTO_GUIA}</strong>?</p>
          )}
        </Modal>
      </>
    );
  };

  const uploadFile = async (idTarefaPost, fileObj) => {
    const file = fileObj.file;
    const url = `/portal/rest/contador/obrigacao/arquivo/upload?id=${idTarefaPost}`;
    const formData = new FormData();
    formData.append('file', file, fileObj.fileName);

    try {
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      });

      console.log(response);
    } catch (error) {
      console.error(error);
      toast.error(error.message || 'An error occurred');
    }

  }

  const handleValorChange = (e) => {
    let { value } = e.target;
    value = value.replace(/[^\d.]/g, '');

    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    setFormulario(prevState => ({
      ...prevState,
      valor: value
    }));
  };

  const enterLoading = async (index) => {
    try {
      await handleFormSubmit();

      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = true;
        return newLoadings;
      });

      setTimeout(() => {
        setLoadings((prevLoadings) => {
          const newLoadings = [...prevLoadings];
          newLoadings[index] = false;
          return newLoadings;
        });
      }, 3000);
    } catch (error) {
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
    }
  };

  const handleSite = () => {
    if (formulario.obrigacao && formulario.urlSite) {
      window.open(formulario.urlSite, '_blank');
    } else {
      toast.error('URL não está disponível.');
    }
  }

  const descricaoBaseadaSituacao = () => {
    switch (formulario.situacao) {
      case 'E':
        return `${formulario.descricao} - ref. ${dayjs(formulario.dataReferencia)}`;
      case 'J':
        return `JUSTIFICADA - ref. ${dayjs(formulario.dataReferencia)}`;
      case 'S':
        return `SEM MOVIMENTACAO - ref. ${dayjs(formulario.dataReferencia)}`
      default:
        return '';
    }
  };

  const handleDescricaoChange = (value) => {
    setFormulario(prevState => ({
      ...prevState,
      descricao: value,
    }));


    setIsEmitida(value === 'E');


  };

  const handleFormSubmit = async () => {
    try {
      await form.validateFields();

      salvarCadastroDeGuia();
    } catch (errorInfo) {
      console.log('Erro de validação:', errorInfo);
    }
  };

  const formatErrorMessage = (message) => {
    const prefix = "br.com.g2b.merp.api.BusinessApiException:";
    if (message.startsWith(prefix)) {
      return message.slice(prefix.length).trim();
    }
    return message;
  };

  const goToBottom = () => {
    setTimeout(() => {
      if (situacaoTarefaRef && situacaoTarefaRef.current) {
        situacaoTarefaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleClose = () => {
    setIsModalOpen(prevState => !prevState)
    setIsModalEmitirClose(false)
    onClose();
    goToBottom();
  };

  const dasButton = obrigacaoId === 7 ? <Radio.Button value="das">DAS</Radio.Button> : null;

  const inputRef = useRef(null);

  const handleCopy = async () => {
    try {
      // Tenta usar a API moderna do clipboard
      await navigator.clipboard.writeText(formulario.clienteCnpj);
      console.log('Texto copiado com sucesso!');
    } catch (err) {
      console.warn('Falha ao copiar usando Clipboard API, tentando método alternativo...', err);

      // Fallback com execCommand
      const tempInput = document.createElement('input');
      tempInput.value = formulario.clienteCnpj;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      console.log('Texto copiado com sucesso (via execCommand)!');
    }
  };

  const SelectMotivo = () => {

    const handleMotivoChange = (value) => {
      setFormulario(prevState => ({
        ...prevState,
        motivo: value
      }));
    };

    const handleSituacaoChange = async (value) => {
      if (tarefasCorrelacionadas.length > 0) {
        setIsTarefaCorrelacionada(value === 'S');
      }
      setFormulario((prevState) => ({
        ...prevState,
        situacao: value,
        motivo: ""
      }));
      setIsRender(value === "E" || value === "J");
    };

    const getOptions = () => {
      const returno = isOptionsMotivo.filter(
        (option) => formulario.situacao[0] === option.value[0]
      );
      return returno;
    };

    const RenderMotivo = () => {

      if (isRender && formulario.situacao[0] === "E") {
        return (
          <FormatItem>
            <div className="central-format-item">
              <label htmlFor="situacao-select">Motivo</label>
              <select
                id="situacao-select"
                className="select-format"
                placeholder="Selecione o Motivo"
                onChange={(e) => handleMotivoChange(e.target.value)}
                value={formulario.motivo}
              >
                <option value="" disabled>
                  Selecione
                </option>
                {getOptions().map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </FormatItem>

        )
      } else if (isRender && formulario.situacao[0] === "J") {
        return (
          <FormatItem>
            <div className="central-format-item">
              <label htmlFor="situacao-select">Motivo</label>
              <select
                id="situacao-select"
                className="select-format"
                placeholder="Selecione o Motivo"
                onChange={handleMotivoChange}
                value={formulario.motivo}
              >
                <option value="" disabled>
                  Selecione
                </option>
                {getOptions().map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </FormatItem>
        )

      } else {
        return (
          null
        );
      }

    };

    return (
      <><FormatItem>
        <div className="central-format-item">
          <label htmlFor="situacao-select">Situação</label>
          <select
            id="situacao-select"
            className="select-format"
            placeholder="Selecione a Situação"
            onChange={(e) => handleSituacaoChange(e.target.value)}
            value={formulario.situacao}
          >
            <option value="" disabled>Selecione</option> {/* Placeholder option */}
            {SituacaoMotivo.map(option => (
              <option key={option.id} value={option.id}>
                {option.nome}
              </option>
            ))}
          </select>
        </div>

      </FormatItem>

        <RenderMotivo />
      </>
    );

  };

  const adicionarInformacoes = async () => {
    const url = "/portal/rest/contador/cliente/nota/atualizar"
    const info = {
      cliente: {
        id: formulario.clienteId.toString(),
      },
      conteudo: infoConteudo,
      id: formulario.clienteId.toString(),
    }
    setIsLoadingAddInfo(true);
    try {
      const response = await axios.post(url, info, {
        withCredentials: true
      });

      if (response) {
        toast.success("Informação adicionada com sucesso!")
        setIsModalAddInformacoesAdicionais(false);
      } else {
        toast.error("Erro ao tentar adicionar informações")
      }

      //console.log(response);
    } catch (err) {
      console.warn(err);
    } finally {
      setIsLoadingAddInfo(false);
    }
  }

  return (
    <>
      <Modal
        title="Cadastro de Guia de Imposto/Declaração"
        width="90%"
        open={isModalEmitirClose}
        onCancel={onClose}
        footer={[
          <Button key="close" onClick={onClose}>
            Fechar
          </Button>,
        ]}
      >
        <div>
          {isLoadingForm ? (
            <>
              {[...Array(3)].map((_, index) => (
                <Skeleton
                  active
                  key={index}
                  variant="rectangular"
                  width="100%"
                  height={8}
                  style={{ padding: "5px 20px" }}
                />
              ))}
            </>
          ) : (
            <div className="scrollY">
              <Form onFinish={handleFormSubmit} form={form} layout="vertical">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "10px",
                  }}
                >
                  <Form.Item>
                    <Radio.Group
                      value={selectedOption}
                      onChange={(e) => setSelectedOption(e.target.value)}
                    >
                      <Radio.Button value="cadastro">Cadastro</Radio.Button>
                      <Radio.Button value="credenciais">
                        Credenciais de acesso
                      </Radio.Button>
                      {dasButton}
                    </Radio.Group>
                  </Form.Item>
                </div>
                {selectedOption === "cadastro" && (
                  <>
                    <FormContent>
                      <div style={{ display: "flex", justifyContent: "right" }}>
                        <Tooltip title="Adicionar informações">
                          <div
                            className="btn-model width bg-padrao"
                            onClick={() =>
                              setIsModalAddInformacoesAdicionais(true)
                            }
                          >
                            <IoAddOutline />
                          </div>
                        </Tooltip>

                        <Tooltip title="Site da Prefeitura">
                          <div className="btn-model width" onClick={handleSite}>
                            <TfiWorld />
                          </div>
                        </Tooltip>
                      </div>

                      <div className="form-content">
                        <Form.Item
                          className="form-item"
                          label="Cliente"
                          name="cliente"
                        >
                          <Input
                            placeholder={formulario.clienteId}
                            disabled={true}
                          />
                        </Form.Item>
                        <div style={{ display: "flex" }}>
                          <div className="float-buttons">
                            <Form.Item
                              className="form-item"
                              label="CNPJ"
                              name="cpnj"
                              ref={inputRef}
                            >
                              <Input
                                value={formatCNPJ(formulario.clienteCnpj)}
                                placeholder={formatCNPJ(formulario.clienteCnpj)}
                                disabled={true}
                              />
                            </Form.Item>
                            <Tooltip title="Copiar">
                              <div
                                className="float-button-copy"
                                onClick={handleCopy}
                              >
                                <div className="float-button">
                                  <div className="button">
                                    <CopyOutlined />
                                  </div>
                                </div>
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                        <Form.Item
                          className="form-item"
                          label="Nome / Razão Social"
                          name="nome-razao"
                        >
                          <Input
                            placeholder={formulario.nomeRazaoSocial}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </div>

                      <div className="form-content">
                        <Form.Item
                          className="form-item"
                          label="Inscrição Estadual"
                          name="ie"
                        >
                          <Input
                            placeholder={formulario.inscricaoEstadual}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Inscrição Municipal"
                          name="im"
                        >
                          <Input
                            placeholder={formulario.inscricaoMunicipal}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="CNAE Anexos"
                          name="cnae"
                        >
                          <Input
                            placeholder={formulario.cnaeAnexos}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </div>

                      <div className="form-content">
                        <Form.Item
                          className="form-item"
                          label="Obrigação"
                          name="obrigacao"
                        >
                          <Input
                            placeholder={formulario.obrigacao}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Sigla"
                          name="sigla"
                        >
                          <Input
                            placeholder={formulario.sigla}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Nome"
                          name="nome"
                        >
                          <Input
                            placeholder={formulario.nome}
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </div>

                      {isModalConfirmRetificacao && <ModalConfirmValor />}

                      <div className="form-content">
                        <Form.Item
                          className="form-item"
                          label="Mês de Referência"
                          name="mesRef"
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={dayjs(formulario.mesRef)}
                                format="MM/YYYY"
                                picker="month"
                                disabled={isContador}
                                onChange={(date, dateString) => {
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    mesRef: `${dateString}-15T03:00:00.000Z`,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>

                        <Form.Item
                          className="form-item"
                          label="Data Vencimento"
                          name="dataVenc"
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={dayjs(formulario.dataVenc)}
                                format="DD/MM/YYYY"
                                disabled={isContador}
                                onChange={(date, dateString) => {
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataVenc: dateString,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>

                        
                        <SelectMotivo />
                      </div>

                      <div className="form-content">
                        <Form.Item
                          className="form-item"
                          label="Descrição"
                          name="descricao"
                          style={{ width: 400 }}
                        >
                          <Input
                            placeholder={descricaoBaseadaSituacao()}
                            defaultValue={formulario.descricao}
                            onChange={handleDescricaoChange}
                          />
                        </Form.Item>

                        <Form.Item
                          className="form-item"
                          label="Valor"
                          name="valor"
                        >
                          <Input
                            placeholder={formulario.valor}
                            //defaultValue={formulario.valor}
                            onChange={handleValorChange}
                            inputMode="numeric"
                            onKeyDown={(event) => {
                              if (
                                !/[0-9]/.test(event.key) &&
                                event.key !== "Backspace" &&
                                event.key !== "Delete"
                              ) {
                                event.preventDefault();
                              }
                            }}
                            className="ant-input"
                            addonBefore="R$"
                            disabled={disableValue}
                          />
                        </Form.Item>

                        <Form.Item
                          className="form-item"
                          label="Disponibilização Portal"
                          name="disponibilizacao"
                        >
                          <Checkbox
                            checked={formulario.liberado}
                            onChange={(event) => {
                              setFormulario((prevState) => ({
                                ...prevState,
                                liberado: event.target.checked,
                              }));
                            }}
                          >
                            Liberado
                          </Checkbox>
                        </Form.Item>

                      </div>
                      <div
                      className="flex-center">
                        <Form.Item className="form-item" name="archive">

                          <UploadDoc 
                            setIsFiles={setIsFiles} 
                            formulario={formulario} 
                            setFormulario={setFormulario}
                            setIsRender={setIsRender} 
                            validaDateForm={validaDateForm} 
                            formatErrorMessage={formatErrorMessage}
                            setIsvalidate={setIsvalidate} 
                            setIsFile={setIsFile} 
                            setIsFileName={setIsFileName} 
                            setRetificacao={setRetificacao}
                            retificacaoFile={retificacaoFile}
                          />
                        </Form.Item>
                      </div>

                      {isTarefaCorrelacionada && (
                        <TabelaCorrelacionadas 
                          tarefasCorrelacionadas={tarefasCorrelacionadas}
                          formulario={formulario}
                        />
                      )}

                      
                      <div
                      className="text-center-margin-3">
                        <span>{info}</span>
                      </div>
                      <div className="justify-content">
                        <Form.Item>
                          <div>
                            <Button
                            className="bg-padrao color-white"
                              loading={loadings[0]}
                              onClick={() => enterLoading(0)}
                            >
                              <SaveOutlined /> Salvar
                            </Button>
                          </div>
                        </Form.Item>
                      </div>
                    </FormContent>
                  </>
                )}

                {selectedOption === "credenciais" && (
                  <CredenciaisAcesso clienteId={formulario.clienteId} />
                )}

                {selectedOption === "das" && (
                  <NotaFiscal
                    onClose={handleClose}
                    idClient={formulario.clienteId}
                  />
                )}

                {isModalAddInformacoesAdicionais && (
                  <ModalAdicionarInformacoes 
                  formulario={formulario}
                  isModalAddInformacoesAdicionais={isModalAddInformacoesAdicionais}
                  setIsModalAddInformacoesAdicionais={setIsModalAddInformacoesAdicionais}
                  />
                )}

               
              </Form>
            </div>
          )}
        </div>
      </Modal>

      {false && (
        <div ref={situacaoTarefaRef}>
          <SituacaoTarefa />
        </div>
      )}
    </>
  );

}
export default PendentesEmitir;